<template>
  <a-modal
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    ok-text="保存"
    cancel-text="取消"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="年份" prop="vintages">
          <a-date-picker
            placeholder="请选择加入年份"
            v-model="form.vintages"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            @change="handleClearAcquireYear"
          />
        </a-form-model-item>
        <a-form-model-item label="资金来源" prop="capitalSource">
          <a-select v-model="form.capitalSource"  >
            <a-select-option :value="item.text" v-for="item in zjlylist">{{
              item.title
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="资金金额" prop="amount">
          <div class="flex">
              <a-input-number :min="0"   v-model="form.amount" />
              <span class="surplus-money">元 </span>
          </div>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>
    
  <script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        applyId: "",
        capitalSource: "",
        amount: "",
        vintages: "",
      },
      rules: {
        vintages: [
          {
             validator: (rule, value, callback) => {
              if (this.form.vintages!='') {
                callback(); // 验证通过
              } else {
                callback(new Error('请选择年份'));
              }
            },
            required: true,
            message: "请选择年份",
            trigger: "change",
          },
        ],
        capitalSource: [
          {
            required: true,
            message: "请选择资金来源",
            trigger: "change",
          },
        ],
        amount: [
          {
            required: true,
            message: "请输入金额",
            trigger: "blur",
          },
        ],
      },
      zh_CN,
      locale,
      applyType: 1,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      zjlylist: [],
      yearShowOne: false,
    };
  },
  methods: {
    init(type, record) {
      this.type = type;
      this.visible = true;
      this.zjlys();
      if (type == "add") {
        this.form = {};
        this.form.vintages=new Date().getFullYear()+"";
        this.title = "添加资金来源";
      } else if(type == "edit"){
        this.title = "编辑资金来源";
        this.form = {
          id: record.id,
          capitalSource: record.capitalSource,
          amount: record.amount,
          vintages:record.vintages?record.vintages:'',
        };
        // console.log(this.form);
      }
    },
    zjlys() {
      getAction("/baseCommon/getDictItemsByCode?code=capital_source ", {}).then((res) => {
        if (res.code == 200) {
          this.zjlylist=res.result;
        }
      });
    },
    handleCancel() {
      this.visible = false;
    },
    submit() {
      if(typeof this.form.vintages == "object"){
        this.form.vintages = new Date(this.form.vintages).getFullYear() + "";
      }

      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.type == "add") {
            let params = this.form;
            // params.applyType = this.applyType;
            // if (
            //   typeof this.form.vintages == "object" &&
            //   this.form.vintages != ""
            // ) {
            //   this.form.vintages =
            //     new Date(this.form.vintages).getFullYear() + "";
            // }
            this.visible = false;
            this.$message.success("添加成功");
            this.$emit("foundPay",{record:params,type:'add'});
          } else {
            let params = this.form;
            if (typeof this.form.vintages == "object") {
              params.vintages = new Date(this.form.vintages).getFullYear() + "";
            }
            // params.birthday = formattedDate;
              // console.log(params);
              this.visible = false;
              this.$message.success("编辑成功");
              this.$emit("foundPay",{record:params,type:'edit'});
          }
          //   if (
          //     typeof this.form.vintages == "object" &&
          //     this.form.vintages != "" &&
          //     this.type == "add"
          //   ) {
          //     this.form.vintages =
          //       new Date(this.form.vintages).getFullYear() + "";
          //   }
          //   postAction("/lxBase/lxSubsidyFund/add", params).then((res) => {
          //     if (res.code == 200) {
          //       this.visible = false;
          //       this.$message.success("添加成功");
          //       this.$emit("foundPay");
          //     } else {
          //       this.$message.error(res.message);
          //     }
          //   });
          // } else {
          //   let params = this.form;
          //   params.applyType = this.applyType;
          //   if (typeof this.form.vintages == "object") {
          //     params.vintages = new Date(this.form.vintages).getFullYear() + "";
          //   }
          //   putAction("/lxBase/lxSubsidyFund/edit", params).then((res) => {
          //     if (res.code == 200) {
          //       this.visible = false;
          //       this.$message.success("编辑成功");
          //       this.$emit("foundPay");
          //     } else {
          //       this.$message.error(res.message);
          //     }
          //   });
          // }
        } else {
          console.log("error submit!!");
          return false;
        }
        
      });
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    handleClearAcquireYear() {
      //  	console.log("111111");
      this.form.vintages = ""; // 或者适当的空值，根据你的业务需求
      this.$forceUpdate();
    },
    panelChangeOne(value) {
      // console.log(value, "111111");
      // this.form.vintages = value;
      const year = moment(value).format('YYYY');
      this.form.vintages =year+"";
      this.yearShowOne = false;
      this.$refs.ruleForm.clearValidate("vintages");
      
    },
  },
};
</script>
  
  <style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
.surplus-money {
  width: 200px;
  display: inline-block;
  margin-left: 12px;
}
</style>
  